module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="b-booking__two-selector-wrapper">\n  <div class="l-grid-container">\n    <div class="b-cost-codes__item-content flex-grid-container">\n      <div class="b-booking__reason-code flex-grid-layout b-cost-codes__item-field"></div>\n      <div class="b-booking__key-contact flex-grid-layout b-cost-codes__item-field"></div>\n    </div>\n  </div>\n</div>\n';

}
return __p
}